module.exports = __webpack_public_path__ + "files/451285a5f5b2f672c6912997cc96c010.png";